import DistributorLayout from '@/layouts/DistributorLayout.vue'

export default [
  {
    path: '/environmental-performance-report',
    name: 'environmentalPerformanceReport',
    component: () =>
      import('@/views/restricted/environmental-performance/EnvironmentalPerformanceReportView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RECYCLING_READ'],
      menuSelected: 'environmentalPerformanceReport'
    }
  }
]
